/**
 * Guard di autenticazione per le route protette.
 *
 * Usa il context AuthProvider per verificare lo stato di autenticazione.
 * Mostra un indicatore di caricamento durante il fetch iniziale del profilo,
 * poi redirige a /login se l'utente non e autenticato.
 */

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

const AuthGuard: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center" style={{ backgroundColor: 'var(--color-background)' }}>
        <span className="text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
          Caricamento…
        </span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default AuthGuard;
